/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 */

export type InvitationStatus =
  (typeof InvitationStatus)[keyof typeof InvitationStatus];

export const InvitationStatus = {
  pending: 'pending',
  accepted: 'accepted',
  expired: 'expired',
} as const;
